import type { TPatientNextVisit, TNextVisitMarkType, IPatientNextVisitFilter } from "./types";
import { createPathParamCRUD, createPathParam, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "patient/next-visit";

export default createService(SLUG, {
  ...createPathParamCRUD<TPatientNextVisit, NoPathParams, IPatientNextVisitFilter>(SLUG),

  markAs: createPathParam<
    TPatientNextVisit,
    { nextVisit: string; type: TNextVisitMarkType },
    Record<string, never>
  >(`${SLUG}/{nextVisit}/{type}`),
});
